import { useAuth } from "@qure/qure-auth";
import { get } from "lodash";
import getEnv from "../utils/getEnv";
import useMedia, { MediaSizes } from "./useMedia";
import { getIsOnpremise } from "../utils";
var useGetViewerRoute = function useGetViewerRoute() {
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var viewerIframeUrl = getEnv("NEXT_PUBLIC_VIEWER_IFRAME_URL");
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var isOnpremise = getIsOnpremise();
  var showNewViewer = get(userInfo, ["settings", "ui_settings", "show_new_viewer"], true);
  if (showNewViewer && viewerIframeUrl && !isMobile && !isOnpremise) {
    return "/viewer-v2/";
  }
  return "/viewer/quredicom/";
};
export default useGetViewerRoute;